module.exports = "/_next/static/images/invest-monotone-c73c3789f9b63aad1f5649494ed6cf1c.svg";